import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const Close = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.391 6.329a.85.85 0 1 0-1.202 1.202l4.504 4.504-4.504 4.504a.85.85 0 1 0 1.202 1.202l4.504-4.504 4.504 4.504a.85.85 0 1 0 1.202-1.202l-4.504-4.504 4.504-4.504a.85.85 0 1 0-1.202-1.202l-4.504 4.504-4.504-4.504Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default Close
